<template>
    <div id="index">
        <div class="visible-xs">
            <div class="head_div flex_end">
                <span @click.stop="passwordLogin">密码登录</span>
            </div>
            <div class="logo_div">
                <h4 class="title">欢迎来到麻醉眼界</h4>
                <div class="user_num" :class='{"value":phone !== ""}'>
                    <input type="Number" @focus="is_keyboard = true" @blur="is_keyboard = false" v-model="phone"
                        placeholder="请输入手机号">
                </div>
                <button class="login" @click="login">登录</button>
                <!-- <div class="flex_center prompt">
                    登录即表示接受
                    <span @click.stop="user_agreement">【用户协议】</span> <span @click.stop="privacy">【隐私保护】</span>
                </div> -->
                <div class="flex_center prompt">
                    还没有账号?
                    <span @click="registered">立即注册</span>
                </div>
            </div>

            <div class="wx_logo" v-if="!is_keyboard">
                <span class="wx_text">
                    第三方登录
                </span>
                <i @click.stop="wx_login"><img src="@/assets/img/wx_icon.png" alt=""></i>
            </div>
        </div>
    </div>
</template>

<script>

    import "@/assets/js/swiper.animate1.0.3.min.js";
    import "@/assets/css/animate.min.css";
    import "@/assets/css/video-js.min.css";
    export default {
        name: "index",
        data() {
            return {
                IMG_URL: this.$IMG_URL,
                is_keyboard: false,//是否打开键盘

                phone: '',//手机
            };
        },
        computed: {},
        components: {

        },
        watch: {
            phone: function (eve) {
                this.$store.commit('setPhone', eve)
            },
        },
        methods: {
            goLndex() {//返回登录
                if (this.$store.state.query_url) {
                    this.$router.replace({ path: this.$store.state.query_url });
                } else {
                    this.$router.replace("/m_index");
                }
            },
            registered() {//注册
                this.$router.push({ path: '/m_registered', query: {  } });
            },
            privacy() {//隐私权
                this.$router.push('/privacy');

            },
            user_agreement() {//用户协议
                this.$router.push('/user_agreement');
            },
            wx_login() {//微信登录
                let that = this;
               
                if (this.$store.state.is_app) {
                    android.loginWx();
                } else {
                    this.GET_Token({
                        success: function (res) {
                            if (res.data.mobile == '' || !res.data.mobile) {
                                layer.open({
                                    content: "绑定手机！",
                                    time: true,
                                    skin: "msg"
                                });
                                setTimeout(() => {
                                    this.$router.push({ path: '/m_binding', query: { member_id: res.data.id } });
                                }, 1000)
                            } else {
                                layer.open({
                                    content: "登录成功！",
                                    time: true,
                                    skin: "msg"
                                });
                                setTimeout(() => {
                                    that.goLndex();
                                }, 1000)
                            }
                        }
                    })
                }
            },
            passwordLogin() {//密码登录
                this.$router.push({ path: '/m_password', query: {} });
            },
            login() {
                if (this.phone == '' || !this.phone) {
                    layer.open({
                        content: "请输入手机号",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                if (this.phone.length !== 11) {
                    layer.open({
                        content: "手机号不为11位",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                if (!this.validationPhone(this.phone)) {
                    layer.open({
                        content: "手机号格式错误",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                let that = this;
                this.$post('mobile_login', {
                    mobile: this.phone,
                }).then(res => {
                    that.$router.push({ path: '/m_code', query: { type: 1, } });

                }).catch(res => {
                     
                    layer.open({
                        content: res.message,
                        time: true,
                        skin: "msg"
                    });
                    setTimeout(() => {
                        that.$router.push({ path: '/m_registered', query: {  } });
                    }, 1000)
                })

            },
            // 判断完毕后加载样式
            setActiveStyleSheet(filename) {
                document.write("<link href=" + filename + " rel=stylesheet>");
            },

        },
        mounted() {
            let that = this;
            this.phone = this.$store.state.phone;
            
            if (this.GetRequest().code) {
                this.wx_login();
            }
            this.getShare();
            if (this._isMobile()) {
                // alert("手机端");
                //   this.$router.replace('/m_index');
            } else {
                // alert("pc端");
                this.$router.replace("/");
            }


            // window.onload = function () {
            //     var w = document.body.clientWidth; //获取屏幕宽度
            //     // 这里*100 是为了取整数
            //     var x = parseInt((w * 100) / 375 * 10) / 10; //获取任意屏幕上的根节点字体大小
            //     document.getElementsByTagName('html')[0].style.fontSize = x + 'px';
            //     //监听屏幕宽度变化
            //     window.onresize = function () {
            //         var w = document.body.clientWidth; //获取屏幕宽度
            //         var x = parseInt((w * 100) / 375 * 10) / 10;; //获取任意屏幕上的根节点字体大小
            //         document.getElementsByTagName('html')[0].style.fontSize = x + 'px';
            //     }
            // }
        }
    };
</script>

<style scoped>
    html,
    body {
        max-width: 100vw;
    }

    .visible-xs {
        width: 86vw;
        overflow: hidden;
        padding-top: 0rem;
        padding: 1.6rem 2.4rem 15rem 2.4rem;
        min-height: calc(100vh - 16.6rem);
    }

    .head_div>span {
        font-size: 1.3rem;
        color: #333;
    }

    .logo_div {
        /* position: fixed;
        top:8vh;
        left:50%;
        transform: translateX(-50%); */
        margin-top: .25rem;
        width: calc(100vw - 4rem);
    }

    .title {
        margin-top: 5rem;
        font-size: 2rem;
        color: 333;
        font-weight: bold;
    }

    .user_num {
        border-bottom: .05rem solid #EFEFEF;
        margin-top: 5.8rem;
    }

    .user_num>input {
        width: 100%;
        height: 4rem;
        font-size: 1.3rem;
        line-height: 4rem;
    }

    .user_num.value {
        border-color: #F24D5B;
    }

    .login {
        width: 100%;
        margin-top: 6vh;
        height: 4.5rem;
        border-radius: 2.2rem;
        background: #F24D5B;
        color: #fff;
        border: 0;
        font-size: 1.8rem;
        box-shadow: 0 0 2.7rem rgba(241, 77, 91, 0.3);
    }

    .prompt {
        margin-top: 3.7rem;
        font-size: 1.3rem;
        color: #656565
    }

    .prompt>span {
        color: #F14D5B;
        margin-left: .4rem;
    }

    .wx_logo {
        position: absolute;
        bottom: 3rem;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
    }

    .wx_logo .wx_text {
        font-size: 1.2rem;
        color: #BABFC0;
        position: relative;
    }

    .wx_logo .wx_text::after {
        content: '';
        position: absolute;
        left: -10rem;
        top: 50%;
        transform: translateY(-50%);
        width: 8.8rem;
        height: .05rem;
        background: #DFDFDF;
    }

    .wx_logo .wx_text::before {
        content: '';
        position: absolute;
        right: -10rem;
        top: 50%;
        transform: translateY(50%);
        width: 8.8rem;
        height: .05rem;
        background: #DFDFDF;
    }

    .wx_logo>i {
        width: 4rem;
        margin: 1.7rem auto 0 auto;

    }
</style>


// WEBPACK FOOTER //
// src/components/minLogin/m_login.vue